<template>
  <div class="perfil">
    <Button layout="back" @click="router.back()" class="show-s">
      <i class="fa fa-arrow-left"></i> Voltar
    </Button>
    <div class="content" v-if="!loader">
      <div class="row">
        <div class="title grid-8">Perfil</div>
        <div class="row grid-4 justify-end">
          <!--  <Button layout="green-go">Editar dados</Button> -->
        </div>
      </div>
      <div class="column section">
        <div class="sub">Dados da empresa</div>
        <div class="row column-s">
          <div class="grid-3 label column">
            <label>CNPJ</label>
            <div>{{ perfil.cnpj }}</div>
          </div>
          <div class="grid-3 label column">
            <label>Razão Social</label>
            <div>{{ perfil.razao_social }}</div>
          </div>
          <div class="grid-3 label column">
            <label>Nome Fantasia</label>
            <div>{{ perfil.nome_fantasia }}</div>
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="column section">
        <div class="sub">Localização</div>
        <div class="row wrap">
          <div class="grid-3 label column">
            <label>CEP</label>
            <div>{{ perfil.cep }}</div>
          </div>
          <div class="grid-3 label column">
            <label>Logradouro</label>
            <div>{{ perfil.logradouro }}</div>
          </div>
          <div class="grid-2 label column">
            <label>Número</label>
            <div>{{ perfil.numero }}</div>
          </div>
          <div class="grid-2 label column">
            <label>Bairro</label>
            <div>{{ perfil.bairro }}</div>
          </div>
          <div class="grid-2 label column">
            <label>Estado</label>
            <div>{{ perfil.estado }}</div>
          </div>
          <div class="grid-2 label column">
            <label>Complemento</label>
            <div>{{ perfil.complemento }}</div>
          </div>
        </div>
      </div>
      <div class="divider"></div>
      <div class="column section">
        <div class="sub">Dados do responsável</div>
        <div class="row column-s">
          <div class="grid-4 label column">
            <label>Nome</label>
            <div>{{ perfil.nome }}</div>
          </div>
          <div class="grid-4 label column">
            <label>E-mail</label>
            <div>{{ perfil.email }}</div>
          </div>
          <div class="grid-4 label column">
            <label>Telefone</label>
            <div>{{ perfil.fone }}</div>
          </div>
        </div>
      </div>
      <Button layout="white-m-gray" @click="router.back()">
        <i class="fa fa-arrow-left"></i> Voltar
      </Button>
    </div>
    <Loader v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader";
import Router from "@/router";

export default {
  name: "perfil",
  components: { Button, Loader },
  data() {
    return { loader: true, router: Router };
  },
  methods: {
    ...mapActions("user", ["LOAD_PERFIL"]),
  },
  computed: {
    ...mapGetters("user", ["perfil"]),
  },
  mounted() {
    this.LOAD_PERFIL().then(() => (this.loader = false));
  },
};
</script>


<style lang="scss" scoped>
@import "@/assets/scss/vars.scss";
.perfil {
  padding: 42px 35px;
  color: $font-color;
  
  .content {
    border-radius: 23px;
    background: $white;
    padding: 32px 35px;
    margin-top: 20px;

    .title {
      font-size: 33px;
      margin-bottom: 20px;
    }

    .sub {
      font-size: 18px;
      margin-bottom: 35px;
      margin-top: 35px;
      font-weight: 500;
      color: $client-2;
    }

    .label {
      color: $gray-6;
      font-size: 15px;
      font-weight: 300;
      margin-bottom: 25px;
      div {
        color: $gray-7;
        font-size: 15px;
        font-weight: 500;
        text-transform: capitalize;
      }
    }
    .section {
      padding-bottom: 40px;
    }
  }
  .loader {
    left: 50%;
    margin-left: -45px;
    margin-top: 25%;
  }
  @media (max-width: $small) {
    padding: 7px;
  }
}
</style>
